export const iconFontAwesomeMaritimeShrimp = (
	<i className="fa-solid fa-shrimp"></i>
);
